import { createAsyncThunk } from "@reduxjs/toolkit";
//import axios from "axios";
//import { API_URL } from "src/utils/apiConfig";
import { apiClient } from '../../helpers/api_helper';
import { unitsError, unitsSuccess } from "./reducer";
import { userId } from "src/helpers/user_id";

export const getUnitsTypes = createAsyncThunk("unity/getUnitsTypes", async () => {
    try {
      const response = await apiClient.get(`/unity/unityorgtypes/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addUnitType = createAsyncThunk("unity/addUnitType", async (unit: any, { dispatch }) => {
    try {
      const response = await apiClient.post(`/unity/unityorgtypes/`, {
          name: unit.name,
          key: unit.key,
          level: unit.level,
          create_user: userId,
          update_user: userId,
        }
      );
      dispatch(unitsSuccess(response));
      return response;
    } catch (error) {
      dispatch(unitsError(error));
      return error;
    }
  }
);

export const updateUnitType = createAsyncThunk("unity/updateUnitType", async (unit: any) => {
    try {
      const response = await apiClient.put(`/unity/unityorgtypes/${unit.id}/`, {
          name: unit.name,
          key: unit.key,
          level: unit.level,
          create_user: userId,
          update_user: userId,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteUnitType = createAsyncThunk("unity/deleteUnitType", async (unitId: any) => {
    try {
      const response = await apiClient.delete(`/unity/unityorgtypes/${unitId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);
